import type { DeleteLabelResponse } from '@vy/api-definition';
import { DeleteLabelResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

type UseDeleteLabelVariables = {
  labelId: string;
};

export function useDeleteLabel(
  options?: UseMutationOptions<DeleteLabelResponse, unknown, UseDeleteLabelVariables>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ labelId }) => {
      const api = getPrivateApi();
      const response = await api.deleteLabel({ labelId });

      return DeleteLabelResponseSchema.parse(response);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: [queryKeys.labels()],
        });
      },
      ...options,
    },
  );
}
